"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _recharts = require("recharts");
var _DoughnutLabel = _interopRequireDefault(require("./DoughnutLabel"));
var _Doughnut2 = _interopRequireDefault(require("./Doughnut.style"));
var _Legend = _interopRequireDefault(require("../../legend/Legend"));
var _helpers = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Doughnut = /*#__PURE__*/function (_Component) {
  function Doughnut(props) {
    var _this;
    _classCallCheck(this, Doughnut);
    _this = _callSuper(this, Doughnut, [props]);
    var colorValues = R.values(props.colors);
    var data = props.data,
      dataKey = props.dataKey;
    _this.state = {
      processedData: (0, _helpers.processCatValues)((0, _helpers.mergeDataWithColor)(data, colorValues), dataKey)
    };
    return _this;
  }
  _inherits(Doughnut, _Component);
  return _createClass(Doughnut, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        height = _this$props.height,
        dataKey = _this$props.dataKey,
        labelKey = _this$props.labelKey,
        currency = _this$props.currency,
        legend = _this$props.legend,
        onItemClick = _this$props.onItemClick,
        _highlightActive = _this$props.highlightActive,
        _removeHighlight = _this$props.removeHighlight,
        prefixId = _this$props.prefixId,
        idKey = _this$props.idKey,
        legendProps = _this$props.legendProps,
        paddingAngle = _this$props.paddingAngle,
        pageSize = _this$props.pageSize,
        minWidth = _this$props.minWidth,
        defaultLabel = _this$props.defaultLabel,
        withPagination = _this$props.withPagination,
        highlightedCategoryIndex = _this$props.highlightedCategoryIndex;
      var _this$state = this.state,
        processedData = _this$state.processedData,
        filledColors = _this$state.filledColors;
      var pieProcessedData = (0, _helpers.filterEmptyValues)(processedData);
      var PieLegend = this.props.legendComponent ? this.props.legendComponent : _Legend["default"];
      var hasTwoOrMore = R.length(pieProcessedData) > 1;
      var activeIndex = R.findIndex(R.propEq('orderIndex', highlightedCategoryIndex))(pieProcessedData);
      return /*#__PURE__*/_react["default"].createElement(_Doughnut2["default"], {
        legend: true,
        minWidth: minWidth
      }, /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: height,
        className: "doughnut-chart"
      }, /*#__PURE__*/_react["default"].createElement(_recharts.PieChart, {
        id: "".concat(prefixId, "Chart")
      }, /*#__PURE__*/_react["default"].createElement(_recharts.Pie, {
        isAnimationActive: false,
        activeIndex: R.findIndex(R.propEq('orderIndex', highlightedCategoryIndex))(pieProcessedData),
        activeShape: function activeShape(props) {
          return Doughnut.renderDoughnutLabel({
            props: props,
            filledColors: filledColors
          });
        },
        data: pieProcessedData,
        dataKey: dataKey,
        nameKey: labelKey,
        innerRadius: "75%",
        outerRadius: "100%",
        onMouseOver: _highlightActive,
        onFocus: _highlightActive,
        onMouseLeave: _removeHighlight,
        onBlur: _removeHighlight,
        onClick: function onClick(activeItem) {
          var categ = R.prop(idKey, activeItem);
          var callback = onItemClick(categ);
          if (typeof callback === 'function') {
            callback();
          }
        },
        startAngle: 90,
        endAngle: -270,
        paddingAngle: hasTwoOrMore ? paddingAngle : 0
      }, pieProcessedData.map(function (entry, index) {
        return /*#__PURE__*/_react["default"].createElement(_recharts.Cell, (0, _helpers.getCellOptions)({
          entry: entry,
          labelKey: labelKey,
          activeIndex: highlightedCategoryIndex !== -1 && activeIndex === -1 ? null : activeIndex,
          index: index
        }));
      }), highlightedCategoryIndex === -1 ? /*#__PURE__*/_react["default"].createElement(_recharts.Label, {
        value: defaultLabel,
        position: "center"
      }) : ''))), legend && /*#__PURE__*/_react["default"].createElement(PieLegend, _extends({
        pageSize: pageSize,
        highlightActive: function highlightActive(item) {
          return _highlightActive(item);
        },
        removeHighlight: function removeHighlight(item) {
          return _removeHighlight(item);
        },
        activeIndex: highlightedCategoryIndex,
        className: "doughnut-legend",
        items: processedData,
        idKey: idKey,
        labelKey: labelKey,
        colors: R.pluck('color', processedData),
        currency: currency,
        onItemClick: onItemClick,
        prefixId: prefixId,
        withPagination: withPagination
      }, legendProps)));
    }
  }]);
}(_react.Component);
_defineProperty(Doughnut, "renderDoughnutLabel", function (_ref) {
  var props = _ref.props,
    filledColors = _ref.filledColors;
  return /*#__PURE__*/_react["default"].createElement(_DoughnutLabel["default"], _extends({}, props, {
    colors: filledColors
  }));
});
Doughnut.defaultProps = {
  defaultLabel: '',
  pageSize: 10,
  paddingAngle: 3,
  dataKey: 'value',
  labelKey: 'label',
  idKey: 'categoryLevel1Id',
  height: 220,
  currency: 'EUR',
  legend: false,
  locale: 'en-GB',
  onItemClick: R.identity,
  highlightActive: R.identity,
  removeHighlight: R.identity,
  highlightedCategoryIndex: -1,
  offset: 0,
  prefixId: null,
  legendComponent: null,
  legendProps: {},
  minWidth: null,
  withPagination: false
};
Doughnut.propTypes = {
  defaultLabel: _propTypes["default"].string,
  pageSize: _propTypes["default"].number,
  paddingAngle: _propTypes["default"].number,
  /** locale used to change the way the value is displayed */
  locale: _propTypes["default"].string,
  /** currency to be displayed together with the value. Compliant with https://en.wikipedia.org/wiki/ISO_4217  */
  currency: _propTypes["default"].string,
  /** Flag to attach the legend to the doughnut */
  legend: _propTypes["default"].bool,
  /** Name of the value key of the data */
  dataKey: _propTypes["default"].string,
  /** Name of the label key of the data */
  labelKey: _propTypes["default"].string,
  /** Name of the id key of the data */
  idKey: _propTypes["default"].string,
  /** height of the doughnut */
  height: _propTypes["default"].number,
  /** color map */
  colors: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,
  /** data object: Fields of interest: label, value, percent(if needed) */
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** action to be triggered on clicking a pie item */
  onItemClick: _propTypes["default"].func,
  highlightActive: _propTypes["default"].func,
  removeHighlight: _propTypes["default"].func,
  highlightedCategoryIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({})]),
  offset: _propTypes["default"].number,
  /** id to prefix elements */
  prefixId: _propTypes["default"].string,
  legendComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  legendProps: _propTypes["default"].shape({}),
  minWidth: _propTypes["default"].number,
  withPagination: _propTypes["default"].bool
};
var _default = exports["default"] = Doughnut;